import type { RefObject, SetStateAction, WheelEvent } from 'react';

import type {
  PointerEventModifiers,
  PointerEventPosition,
  RelativeAbsolutePosition,
} from '../../../../types/pointer-events.js';
import type { InteractionMode, InteractionTriggers } from '../../types.js';

export const panMouseClickOrTap = ({
  event,
  lastMousePositionRef,
}: {
  event: PointerEventPosition & PointerEventModifiers;
  lastMousePositionRef: RefObject<RelativeAbsolutePosition | undefined>;
}) => {
  const { position } = event;

  lastMousePositionRef.current = position;
};
export const panMouseHover = ({
  event,
  pinned,
  lastMousePositionRef,
  cursorMode,
  setCursorMode,
  onHover,
}: {
  event: PointerEventPosition & PointerEventModifiers;
  pinned: boolean;
  lastMousePositionRef: RefObject<RelativeAbsolutePosition | undefined>;
  cursorMode: InteractionMode | 'zoomOut';
  setCursorMode: (value: SetStateAction<'zoomOut' | InteractionMode>) => void;
  onHover?: (event: {
    triggeredBy: InteractionTriggers;
    position: RelativeAbsolutePosition;
  }) => void;
}) => {
  const { position } = event;
  if (!pinned) {
    onHover?.({ triggeredBy: 'pointer', position });
  }
  lastMousePositionRef.current = position;
  if ('pan' !== cursorMode) {
    setCursorMode('pan');
  }
};

export const panMouseWheel = ({
  event,
  onPanChange,
}: {
  event: WheelEvent;
  onPanChange?: (event: {
    triggeredBy: InteractionTriggers;
    delta: number;
  }) => void;
}) => {
  const horizontal = event.deltaX && event.deltaX !== 0;
  if (horizontal) {
    onPanChange?.({ triggeredBy: 'pointer', delta: event.deltaX });
  }
};
